import List from '~/common/components/Lists/List';
import ListItem from '~/common/components/Lists/ListItem';
import Text from '~/common/components/Texts/Text';
import { CalculationTypes, FormulaType } from '~/pages/IncomeCalculator/enums';
import type { CalculationResult } from '~/pages/IncomeCalculator/types';
import { pixelsToRem } from '~/theme/typography';

import BreakdownContainer from '../../BreakdownContainer';
import lang from '../../language.json';
import BreakdownColumnBox from '../../styles/BreakdownColumnBox';
import SingleLineValue from '../../styles/SingleLineValue';

function getTemplateFormula(
  formulas: CalculationResult['formulas'],
  calculatorType: number,
) {
  const formula = formulas.find((f) =>
    [
      FormulaType.SSIAwardLetterMonthlyIncomeLineThree,
      FormulaType.SSIAwardLetterMonthlyIncomeLineThreeFHA,
      FormulaType.SSI1099MonthlyIncomeLine3Conv,
      FormulaType.SSI1099MonthlyIncomeLine3FHA,
      FormulaType.SSI1040MonthlyIncome,
      FormulaType.SSI1040MonthlyIncomeFHA,
    ].includes(f.formulaId),
  );

  if (calculatorType === CalculationTypes.SocialSecurityBankStatement) {
    return lang.FORMULAS[`${formula?.formulaId}_CR`];
  }

  return lang.FORMULAS[formula?.formulaId];
}

type SSACalculationBreakdownProps = {
  selectedResult: CalculationResult;
  hideAccordion?: boolean;
  onNewWindow?: (...args: any[]) => any;
};

const SSACalculationBreakdown = ({
  selectedResult,
  onNewWindow,
  hideAccordion = false,
}: Readonly<SSACalculationBreakdownProps>) => {
  const formula = getTemplateFormula(
    selectedResult.formulas,
    selectedResult.calculatorTypeId,
  );

  return (
    <div>
      <BreakdownContainer
        header={lang.HEADERS[selectedResult.calculatorTypeId]}
        onNewWindow={onNewWindow}
        hideAccordion={hideAccordion}
      >
        {formula && (
          <SingleLineValue title={lang.MONTHLY_CALC_HEADER} value={formula} />
        )}
        <BreakdownColumnBox title={lang.CALCULATION} mb={4}>
          <List fontSize={pixelsToRem(14)}>
            {selectedResult.formulas.map(({ formulaId, formula }) => (
              <Text as={ListItem} key={formulaId}>
                {!formula.trim() && <br />}
                {formula}
              </Text>
            ))}
          </List>
        </BreakdownColumnBox>
        <SingleLineValue
          title={lang.MONTHLY_INCOME}
          value={selectedResult.calculationAmount}
          isCurrency
        />
      </BreakdownContainer>
    </div>
  );
};

export default SSACalculationBreakdown;
